import { Controller } from "@hotwired/stimulus";
import Chart from 'chart.js/auto';
import { randomColor } from 'randomcolor'
import { randomColors } from '../helpers/colors';

export default class ChartController extends Controller {
  static LABEL_MAX_LENGTH = 15;

  connect() {
    this.render();
  }

  render() {
    if (!this.ele) return;

    const ctx = this.ele.getContext('2d');

    this.graph = new Chart(
      ctx,
      { type: this.chartType, data: this.data, options: this.options }
    );
  }

  get chartType() {
    return this._chartType = this._chartType || this.element.dataset.chartType;
  }

  get ele() {
    return this._ele = this._ele || $(this.element).find('canvas')[0];
  }

  get metrics() {
    return this._metrics = this._metrics || JSON.parse(this.element.dataset.metrics);
  }

  get options() {
    let baseOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: this.legend,
      },
    };

    if (this.chartType === 'line') {
      baseOptions.scales = {
        x: {
          display: true,
          title: {
            display: true,
            text: this.xAxisLabel,
            fontSize: 14,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: this.yAxisLabel,
            fontSize: 14,
          },
        },
      };
    } else if (this.chartType === 'bar') {
      baseOptions.indexAxis = 'y';
    }
    return baseOptions;
  }

  get xAxisLabel() {
    return this.element.dataset.xAxisLabel
  }

  get yAxisLabel() {
    return this.element.dataset.yAxisLabel
  }

  get legend() {
    switch (this.chartType) {
      case 'graph': return { display: false };
      case 'pie': return this.pieChartLegend;
      default: return null;
    }
  }

  get pieChartLegend() {
    return  {
      onClick: null,
      position: 'right',
      padding: 10,
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;
          const chartFullView = !!$(this.element).data('chart-full-view');
          const legends = chartFullView ? datasets[0].data : datasets[0].data.slice(0, 5);
          return legends.map((data, i) => {
            const numberText = `(${data})`
            const initText = `${chart.data.labels[i]} ${numberText}`;
            const shortText = `${chart.data.labels[i].slice(0, ChartController.LABEL_MAX_LENGTH - numberText.length)}..${numberText}`;
            const text = initText.length > ChartController.LABEL_MAX_LENGTH && !chartFullView ? shortText : initText;
            return {
              text: text,
              fillStyle: datasets[0].backgroundColor[i],
              index: i,
              fill: i > 4
            };
          })
        }
      }
    };
  }

  get legend() {
    switch (this.chartType) {
      case 'graph': return { display: false };
      case 'pie': return this.pieChartLegend;
      default: return null;
    }
  }

  get pieChartLegend() {
    return  {
      onClick: null,
      position: 'right',
      padding: 10,
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;
          const chartFullView = !!$(this.element).data('chart-full-view');
          const legends = chartFullView ? datasets[0].data : datasets[0].data.slice(0, 5);
          return legends.map((data, i) => {
            const numberText = `(${data})`
            const initText = `${chart.data.labels[i]} ${numberText}`;
            const shortText = `${chart.data.labels[i].slice(0, ChartController.LABEL_MAX_LENGTH - numberText.length)}..${numberText}`;
            const text = initText.length > ChartController.LABEL_MAX_LENGTH && !chartFullView ? shortText : initText;
            return {
              text: text,
              fillStyle: datasets[0].backgroundColor[i],
              index: i,
              fill: i > 4
            };
          })
        }
      }
    };
  }

  get legend() {
    switch (this.chartType) {
      case 'graph': return { display: false };
      case 'pie': return this.pieChartLegend;
      default: return null;
    }
  }

  get pieChartLegend() {
    return  {
      onClick: null,
      position: 'right',
      padding: 10,
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;
          const chartFullView = !!$(this.element).data('chart-full-view');
          const legends = chartFullView ? datasets[0].data : datasets[0].data.slice(0, 5);
          return legends.map((data, i) => {
            const numberText = `(${data})`
            const initText = `${chart.data.labels[i]} ${numberText}`;
            const shortText = `${chart.data.labels[i].slice(0, ChartController.LABEL_MAX_LENGTH - numberText.length)}..${numberText}`;
            const text = initText.length > ChartController.LABEL_MAX_LENGTH && !chartFullView ? shortText : initText;
            return {
              text: text,
              fillStyle: datasets[0].backgroundColor[i],
              index: i,
              fill: i > 4
            };
          })
        }
      }
    };
  }

  get legend() {
    switch (this.chartType) {
      case 'graph': return { display: false };
      case 'pie': return this.pieChartLegend;
      default: return null;
    }
  }

  get pieChartLegend() {
    return  {
      onClick: null,
      position: 'right',
      padding: 10,
      labels: {
        generateLabels: (chart) => {
          const datasets = chart.data.datasets;
          const chartFullView = !!$(this.element).data('chart-full-view');
          const legends = chartFullView ? datasets[0].data : datasets[0].data.slice(0, 5);
          return legends.map((data, i) => {
            const numberText = `(${data})`
            const initText = `${chart.data.labels[i]} ${numberText}`;
            const shortText = `${chart.data.labels[i].slice(0, ChartController.LABEL_MAX_LENGTH - numberText.length)}..${numberText}`;
            const text = initText.length > ChartController.LABEL_MAX_LENGTH && !chartFullView ? shortText : initText;
            return {
              text: text,
              fillStyle: datasets[0].backgroundColor[i],
              index: i,
              fill: i > 4
            };
          })
        }
      }
    };
  }

  get data() {
    return { labels: this.labels, datasets: this.datasets };
  }

  get labels() {
    return this._labels = (this._labels || JSON.parse(this.element.dataset.labels));
  }

  get datasets() {
    let colors = this.generateColors(this.metrics.length);
    return [{
      label: '',
      data: this.metrics.map((m) => parseInt(m, 10)),
      backgroundColor: colors,
      hoverOffset: 4,
    }];
  }

  generateColors(numberOfColors) {
    const colors = []
    let i = 0;
    while (colors.length < numberOfColors) {
      i++;
      if (i > randomColors.length) {
        colors.push(randomColor());
      } else {
        colors.push(randomColors[i]);
      }
    }
    return colors;
  }
}